import React from 'react'

import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'

const DISCLAIMER_MESSAGE =
  'Luxury Escapes Charter flights to the Maldives only depart Melbourne on Mondays and Male on Sundays'

function FlightDealAgentHubDisclaimer() {
  return (
    <BodyTextBlock
      startIcon={<LineInfoCircleIcon />}
      variant="small"
      colour="neutral-two"
    >
      {DISCLAIMER_MESSAGE}
    </BodyTextBlock>
  )
}

export default FlightDealAgentHubDisclaimer
